import './index.less'
import { getGoodsRecommend, shopifyCartAdd } from "@utils/api.js";

document.addEventListener('DOMContentLoaded', function () {
  if(!customElements.get('jky-app-recommend-products')) {
    class JkyAppRecommendProducts extends HTMLElement {
      constructor() {
        super();
        this.isMobile = window.innerWidth < 1024;
        this.variantId = this.getAttribute('data-variant-id') || '';
        this.position = this.getAttribute('data-position') || 'bottom';

        this.viewMoreText = this.getAttribute('data-view-more-text');
        this.addToCartText = this.getAttribute('data-add-to-cart-text');
        this.buyNowText = this.getAttribute('data-buy-now-text')

        this.viewMoreStyle = this.getAttribute('data-view-more-style') || 'secondary';
        this.addToCartStyle = this.getAttribute('data-add-to-cart-style') || 'secondary';
        this.buyNowStyle = this.getAttribute('data-buy-now-style') || 'primary';
      }
      connectedCallback() {
        this.innerHTML = this.renderSkeleton();
        this.init();

        // 新 main-product 触发variant变化 - 改变当前变体
        if (document.querySelector('variant-fields')) {
          document.addEventListener('variantChangeEvent', e => {
            const currentVariant = e.detail.variant
            if (currentVariant) {
              this.variantId = currentVariant.id
              this.innerHTML = this.renderSkeleton();
              this.init()
            }
          })
        }

        // 旧 main-product 触发variant变化 - 改变当前变体
        const variantWrap = document.querySelector(".variant-input-wrap")
        if(variantWrap) { // 就main-product
          variantWrap.querySelectorAll('label').forEach(item => {
            item.onclick = (e) => {
              this.variantId = e.currentTarget.dataset.productLabel
              this.innerHTML = this.renderSkeleton();
              this.init()
            }
          })
        }
      }
      disconnectedCallback() {
        this.swiper?.destroy()
        this.swiper = null
      }
      async init() {
        try {
          const { data } = await getGoodsRecommend({ skuId: this.variantId, });
          if (data.goods && data.goods.length > 0) {
            this.style.display = 'block'
            this.innerHTML = this.renderDOM(data);
            this.initSwiper(data.goods);
            this.initEvent();
          } else {
            // 如果没有推荐商品，隐藏组件并清空内容
            this.style.display = 'none'
            this.innerHTML = ''
          }
        } catch(err) {
          this.style.display = 'none'
          this.innerHTML = ''
        }
      }
      // 渲染骨架屏
      renderSkeleton() {
        return `
          <h2 class="mx-4 lg:mx-0 w-72 h-7 lg:w-60 bg-[#EEE] skeleton"></h2>
          <h4 class="mx-4 lg:mx-0 w-36 h-[1.125rem] mt-1 lg:w-30 lg:h-6 lg:mt-1.5 px-4 bg-[#EEE] skeleton"></h4>
          <ul class="w-full flex gap-x-3 lg:gap-x-5 px-4 mt-3 lg:px-0 overflow-hidden">
            ${this.renderItemSkeleton()}
          </ul>
        `
      }
      renderItemSkeleton() {
        let html = '';
        html = Array.from({ length: 5 }, () => (`
          <li class="flex-shrink-0 w-40 lg:w-[13.125rem] overflow-hidden">
            <div class="w-40 h-40 lg:w-[13.125rem] lg:h-40 rounded-lg bg-[#EEE] skeleton"></div>
            <div class="flex flex-col w-full items-start ${['bottom', 'single'].includes(this.position) ? 'lg:items-center lg:px-1.5' : ''} mt-3">
              <div class="flex flex-col w-full h-[3.75rem] lg:h-11">
                <p class="w-full h-3.5 bg-[#EEE] skeleton"></p>
                <p class="w-3/5 h-3.5 mt-1 bg-[#EEE] skeleton"></p>
              </div>
              <p class="w-full flex justify-start ${['bottom', 'single'].includes(this.position) ? 'lg:justify-center' : ''} gap-x-2 mt-2">
                <span class="block w-2/5 h-5 lg:h-6 bg-[#EEE] skeleton"></span>
                <span class="block w-2/5 h-5 lg:h-6 bg-[#EEE] skeleton"></span>
              </p>
              <div class="flex flex-col items-start ${['bottom', 'single'].includes(this.position) ? 'lg:items-center' : ''} max-w-full w-full lg:w-fit lg:min-w-40 gap-y-2 mt-4">
                ${this.viewMoreText
                  ? `<div class="w-full h-6 rounded-xl bg-[#EEE] skeleton"></div>`
                  : ''
                }
                ${this.viewMoreText
                  ? `<div class="w-full h-6 rounded-xl bg-[#EEE] skeleton"></div>`
                  : ''
                }
                ${this.buyNowText && !(this.viewMoreText && this.addToCartText)
                  ? `<div class="w-full h-6 rounded-xl bg-[#EEE] skeleton"></div>`
                  : ''
                }
              </div>
            </div>
          </li>
        `)).join('')

        return html
      }
      // 渲染 DOM
      renderDOM({ title, subTitle, goods = [] }) {
        const sku_card_bg = this.getAttribute("data-sku-card-bg")
        // 是否开启了 自动折扣价
        const open_auto_discount_price = this.getAttribute("data-open-auto-discount-price") === "true"
        // 折扣角标
        const data_discount_tag_display_style = this.getAttribute("data-discount-tag-display-style")
        const discount_amount_display_style = this.getAttribute("data-discount-amount-display-style")
        const discount_percent_display_style = this.getAttribute("data-discount-percent-display-style")
        return `
          ${title
            ? `<h2 class="px-4 lg:px-0 text-xl lg:text-lg text-[#1A1A1A] font-semibold lg:font-medium">${title}</h2>`
            : ''
          }
          ${subTitle
            ? `<h4 class="px-4 lg:px-0 font-normal text-xs text-[#999] lg:text-base lg:text-[#666] mt-1 lg:mt-1.5">${subTitle}</h4>`
            : ''
          }
          <!-- Swiper -->
          <div class="swiper w-full px-4 mt-3 ${goods.length >= 3 ? 'pb-8' : ''} lg:p-0 relative">
            <div class="swiper-wrapper">
              ${this.renderSlides({ sku_card_bg, open_auto_discount_price, data_discount_tag_display_style, discount_amount_display_style, discount_percent_display_style, goods })}
            </div>
            <div class="w-full h-1 flex items-center justify-center gap-x-1 !bottom-0 lg:hidden swiper-pagination swiper-app-recommend-products-pagination"></div>
          </div>
          <div class="hidden lg:flex swiper-button-prev swiper-app-recommend-products-prev opacity-0"></div>
          <div class="hidden lg:flex swiper-button-next swiper-app-recommend-products-next opacity-0"></div>
        `
      }
      renderSlides({ sku_card_bg, open_auto_discount_price, data_discount_tag_display_style, discount_amount_display_style, discount_percent_display_style, goods }) {
        let html = '';
        html = goods.map(item => {
          const current_price = Math.min(item.autoDiscountPrice || 0, item.price || 0)
          const origin_price = Math.max(item.autoDiscountPrice || 0, item.price || 0, item.originalPrice || 0)
          let money_format = window?.pageInfo?.currency?.money_format?.replace('{{amount}}', '{{amount_no_decimals}}')
          money_format = money_format?.replace('{{amount_with_comma_separator}}', '{{amount_no_decimals_with_comma_separator}}')
          const discount_amount = formatMoney(Math.floor(item.autoDiscountAmount / 100) * 100, money_format)
          return `
            <div class="swiper-slide w-40 lg:w-[13.125rem] overflow-hidden" data-title="${item.title}">
              <a href="${window.location.origin}/products/${item.handle}?variant=${item.skuId}&action_tag=Recommended" data-type="pic" class="block w-40 h-40 lg:w-[13.125rem] lg:h-40 rounded-lg relative" style="background-color:${sku_card_bg}">
                <img alt="${item.title}" class="w-full h-full rounded-lg !object-contain" src="${item.image}" loading="lazy" />
                ${item.promotion
                  ? `<span class="absolute top-2.5 right-2.5 lg:right-2 text-sm font-medium text-primary">${item.promotion}</span>`
                  : open_auto_discount_price
                    ? data_discount_tag_display_style === 'amount'
                      ? item.autoDiscountAmount > 0
                        ? `<span class="absolute top-2.5 right-2.5 lg:right-2 text-sm font-medium text-primary">${discount_amount_display_style.replace('()', discount_amount)}</span>`
                        : ''
                      : item.autoDiscountPercentage > 0
                        ? `<span class="absolute top-2.5 right-2.5 lg:right-2 text-sm font-medium text-primary">${discount_percent_display_style.replace('()', item.autoDiscountPercentage)}</span>`
                        : ''
                    : ''
                }
              </a>
              <div class="flex flex-col w-full items-start ${['bottom', 'single'].includes(this.position) ? 'lg:items-center' : ''} lg:px-1.5 mt-3">
                <a
                  href="${window.location.origin}/products/${item.handle}?variant=${item.skuId}&action_tag=Recommended"
                  data-type="text"
                  class="text-sm text-[#1A1A1A] font-medium h-[3.75rem] leading-[1.26rem] lg:h-11 lg:leading-[1.375rem] line-clamp-3 lg:line-clamp-2 ${['bottom', 'single'].includes(this.position) ? 'lg:text-center' : ''}"
                  title="${item.title}"
                >${item.title}</a>
                <p class="flex items-center gap-x-2 mt-2">
                  ${open_auto_discount_price && item.autoDiscountPrice > 0
                    ? `<span class="text-sm lg:text-base text-[#666] font-medium">${formatMoney(current_price, pageInfo.currency.money_format)}</span>`
                    : `<span class="text-sm lg:text-base text-[#666] font-medium">${formatMoney(item.price, pageInfo.currency.money_format)}</span>`
                  }
                  ${open_auto_discount_price && item.autoDiscountPrice > 0
                    ? `<span class="text-xs lg:text-sm text-[#B3B3B3] line-through">${origin_price > current_price ? formatMoney(origin_price, pageInfo.currency.money_format) : ''}</span>`
                    : `<span class="text-xs lg:text-sm text-[#B3B3B3] line-through">${Number(item.originalPrice || 0) > Number(item.price || 0) ? formatMoney(item.originalPrice, pageInfo.currency.money_format) : ''}</span>`
                  }
                </p>
                <div class="flex flex-col items-start ${['bottom', 'single'].includes(this.position) ? 'lg:items-center' : ''} max-w-full w-full lg:w-fit lg:min-w-40 gap-y-2 mt-4">
                  ${this.viewMoreText
                    ? `<jds-button class="w-full" variant="${this.viewMoreStyle}" size="small" data-type="view-more" data-id="${item.skuId}" data-title="${item.title}" data-href="${window.location.origin}/products/${item.handle}?variant=${item.skuId}&action_tag=Recommended">${this.viewMoreText}</jds-button>`
                    : ''
                  }
                  ${this.addToCartText
                    ? `<jds-button class="w-full" variant="${this.addToCartStyle}" size="small" data-type="add-to-cart" data-title="${item.title}" data-id="${item.skuId}">${this.addToCartText}</jds-button>`
                    : ''
                  }
                  ${this.buyNowText && !(this.viewMoreText && this.addToCartText)
                    ? `<jds-button class="w-full" variant="${this.buyNowStyle}" size="small" data-type="checkout" data-title="${item.title}" data-id="${item.skuId}">${this.buyNowText}</jds-button>`
                    : ''
                  }
                </div>
              </div>
            </div>
          `
        }).join('')

        return html
      }
      // 初始化 swiper
      initSwiper(goods) {
        this.swiper?.destroy()
        this.swiper = null

        const prevBtn = this.querySelector('.swiper-app-recommend-products-prev')
        const nextBtn = this.querySelector('.swiper-app-recommend-products-next')

        this.swiper = new Swiper(this.querySelector('.swiper'), {
            slidesPerView: 'auto',
            spaceBetween: (this.isMobile || this.position === 'right') ? 12 : 20,
            navigation: {
              prevEl: prevBtn,
              nextEl: nextBtn,
            },
            pagination: goods.length > 2 ? {
              el: '.swiper-app-recommend-products-pagination',
              type: 'bullets', // 明确指定分页类型为 bullets
              clickable: true,
              bulletClass: 'swiper-pagination-item',
              bulletActiveClass: 'swiper-pagination-item-active',
              modifierClass: 'swiper-pagination-',
              renderBullet: function (index, className) {
                return `<span class="${className}"></span>`;
              },
            } : false,
        });

        // 更新 左右箭头状态
        requestAnimationFrame(() => {
          prevBtn.classList.remove('opacity-0')
          nextBtn.classList.remove('opacity-0')
        })
      }
      initEvent() {
        // 监听 a 链接，点击事件
        this.querySelectorAll('a').forEach(a => {
          a.addEventListener('click', (e) => {
            // 数据埋码
            gaPushDataLayer('recommend_products_user_clicks', {
              product_spu_name: this.getAttribute('data-product-title'), // 识别页面产品spu标题名称text
              module: "Recommend Product Display", // 固定名称Parameter
              position: e.currentTarget.closest('.swiper-slide').getAttribute('data-title'), // 识别配置产品sku名称 text
              button_name: e.currentTarget.getAttribute('data-type'), // pic 或 text
              link: e.currentTarget.getAttribute('href'), // 跳转链接
            })
          })
        })

        // 监听 button 点击事件
        this.querySelectorAll('jds-button').forEach(button => {
          button.addEventListener('click', async (e) => {
            button.setAttribute('loading', true);
            const actionType = e.currentTarget.getAttribute('data-type');
            const skuId = e.currentTarget.getAttribute('data-id');
            const skuTitle = e.currentTarget.getAttribute('data-title');
            if (actionType === 'add-to-cart') {
              // 触发添加到购物车的事件
              const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

              try {
                const data = await shopifyCartAdd({ items: [{ id: Number(skuId), quantity: 1, properties: { Action: 'Recommended' } }] });
                if(cart) {
                  cart.renderContents(data)
                } else {
                  window.location.href = '/cart'
                }
              } catch(err) {
                console.log(err)
              } finally {
                button.removeAttribute('loading');

                // 数据埋码
                gaPushDataLayer('recommend_products_user_clicks', {
                  product_spu_name: this.getAttribute('data-product-title'), // 识别页面产品spu标题名称text
                  module: "Recommend Product Display", // 固定名称Parameter
                  position: skuTitle, // 识别配置产品sku名称 text
                  button_name: this.addToCartText, // 按钮名称文本text
                  type: this.position === 'right' ? 'right_above_cart' : this.position === 'bottom' ? 'top_above_nav' : 'detail_body', // 根据展示位置固定名称：商详页头部-头部最下侧（二级导航上方）:top_above_nav;商详页头部-右侧（加购按钮上方):right_above_cart;商详页卖点内容位置:detail_body
                })
              }
            } else if (actionType === 'checkout') {
              // 触发立即购买的事件
              try {
                // 生成 checkout url，并跳转
                const checkoutUrl = await createCartAndCheckout([{ id: skuId, quantity: 1, properties: { Action: 'Recommended' } }], { Action: 'Recommended' })
                if (checkoutUrl) {
                  window.Jackery.Utils.isiOS()
                    ? (window.location.href = checkoutUrl)
                    : window.open(checkoutUrl, '_blank');
                }
              } catch(err) {
                console.log(err)
              } finally {
                button.removeAttribute('loading');

                // 数据埋码
                gaPushDataLayer('recommend_products_user_clicks', {
                  product_spu_name: this.getAttribute('data-product-title'), // 识别页面产品spu标题名称text
                  module: "Recommend Product Display", // 固定名称Parameter
                  position: skuTitle, // 识别配置产品sku名称 text
                  button_name: this.buyNowText, // 按钮名称文本text
                  type: this.position === 'right' ? 'right_above_cart' : this.position === 'bottom' ? 'top_above_nav' : 'detail_body', // 根据展示位置固定名称：商详页头部-头部最下侧（二级导航上方）:top_above_nav;商详页头部-右侧（加购按钮上方):right_above_cart;商详页卖点内容位置:detail_body
                })
              }
            } else {
              // view more
              const href = e.currentTarget.getAttribute('data-href');
              window.open(href, '_blank')

              button.removeAttribute('loading');

              // 数据埋码
              gaPushDataLayer('recommend_products_user_clicks', {
                product_spu_name: this.getAttribute('data-product-title'), // 识别页面产品spu标题名称text
                module: "Recommend Product Display", // 固定名称Parameter
                position: skuTitle, // 识别配置产品sku名称 text
                button_name: this.viewMoreText, // 按钮名称文本text
                link: href, // 跳转链接
              })
            }
          })
        })
      }
    }
    customElements.define('jky-app-recommend-products', JkyAppRecommendProducts);
  }
})